module.exports = __webpack_public_path__ + "img/hero-photo-apgl.048b3196.jpg";